import { render, staticRenderFns } from "./PsoriasisFootModel.vue?vue&type=template&id=89c298aa&scoped=true&"
import script from "./PsoriasisFootModel.vue?vue&type=script&lang=js&"
export * from "./PsoriasisFootModel.vue?vue&type=script&lang=js&"
import style0 from "./PsoriasisFootModel.vue?vue&type=style&index=0&id=89c298aa&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89c298aa",
  null
  
)

export default component.exports